import AbstractApiRepository from '~base/api/AbstractApiRepository';

export default class AccessTokenApiRepository extends AbstractApiRepository {
  set = (token: string) => {
    this.apiClient.setAccessToken(token);
  };

  delete = () => {
    this.apiClient.deleteAccessToken();
  };
}
